import * as React from 'react';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';

interface PlaybackButtonProps {
    id: string
    icon: string;
    isKeyboardShortcutVisible: boolean;
    shortcutKey: string;
    onClick: () => void;
}

export const PlaybackButton = ({ id, icon, isKeyboardShortcutVisible, shortcutKey, onClick }: PlaybackButtonProps) => {
    return (
        <button id={id} className="btn btn-primary" onClick={(e: any) => { e.target.blur(); onClick() }}>
            <i className={"fas " + icon} aria-hidden="true"></i>
            &nbsp;
            <KeyboardShortcutTooltip show={isKeyboardShortcutVisible} keyName={shortcutKey} />
        </button>
    );
}
